var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sections" }, [
      _vm.withPersonalData
        ? _c(
            "section",
            [
              _c("h3", [_vm._v("Mein Name")]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "FormGroup",
                        { attrs: { label: "Anrede" } },
                        [
                          _c("SalutationSelect", {
                            model: {
                              value: _vm.salutation,
                              callback: function($$v) {
                                _vm.salutation = $$v
                              },
                              expression: "salutation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-2 mt-md-0", attrs: { md: "3" } },
                    [
                      _c(
                        "FormGroup",
                        { attrs: { label: "Vorname" } },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.firstName,
                              callback: function($$v) {
                                _vm.firstName = $$v
                              },
                              expression: "firstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-2 mt-md-0", attrs: { md: "3" } },
                    [
                      _c(
                        "FormGroup",
                        { attrs: { label: "Nachname" } },
                        [
                          _c("b-input", {
                            model: {
                              value: _vm.lastName,
                              callback: function($$v) {
                                _vm.lastName = $$v
                              },
                              expression: "lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type
        ? _c("section", [
            _vm.type === _vm.types.external
              ? _c("div", { staticClass: "mb-3" }, [
                  _c("div", [
                    _vm._v(
                      "\n\t\t\t\t\tDa du als externer Berater/Vermittler/Dienstleister im Auftrag eines anderen Unternehmens tätig\n\t\t\t\t\tbist, ist für die Zufriedenheit von Kandidaten und Firmen (Verhinderung von Mehrfachsendung von\n\t\t\t\t\tKandidaten an die gleiche Auftraggeberfirma) und den absoluten Geheimhaltungs- und Datenschutz\n\t\t\t\t\tsowie für die Verrechnung von unseren kostenpflichtigen Dienstleistungen erforderlich:\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3" }, [
                    _vm._v(
                      "\n\t\t\t\t\tDeine Angaben werden absolut vertraulich behandelt und nicht an den Mitbewerb weitergegeben!\n\t\t\t\t\tFalsche Angaben führen zur Anzeige.\n\t\t\t\t"
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.dataTitle))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: {
                      label: _vm.companyNameLabel,
                      state: _vm.companyNameValid,
                      "invalid-feedback": _vm.companyNameError,
                      "feedback-beneath": ""
                    }
                  },
                  [
                    _c("b-input", {
                      model: {
                        value: _vm.companyName,
                        callback: function($$v) {
                          _vm.companyName = $$v
                        },
                        expression: "companyName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "FormGroup",
                  {
                    staticClass: "mt-3",
                    attrs: {
                      label:
                        "Meine Rolle/Funktion im Unternehmen/in der Organisation",
                      state: _vm.roleValid,
                      "invalid-feedback": _vm.roleError,
                      "feedback-beneath": ""
                    }
                  },
                  [
                    _c("b-input", {
                      model: {
                        value: _vm.role,
                        callback: function($$v) {
                          _vm.role = $$v
                        },
                        expression: "role"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              label: "Staat",
                              state: _vm.countryValid,
                              "invalid-feedback": "Bitte wähle einen Staat aus",
                              "feedback-beneath": ""
                            }
                          },
                          [
                            _c("CountrySelect", {
                              attrs: { meta: _vm.meta },
                              model: {
                                value: _vm.country,
                                callback: function($$v) {
                                  _vm.country = $$v
                                },
                                expression: "country"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-3 mt-md-0", attrs: { md: "2" } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              label: "PLZ",
                              state: _vm.zipValid,
                              "invalid-feedback": "Bitte gib eine PLZ ein",
                              "feedback-beneath": ""
                            }
                          },
                          [
                            _c("b-input", {
                              model: {
                                value: _vm.zip,
                                callback: function($$v) {
                                  _vm.zip = $$v
                                },
                                expression: "zip"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-3 mt-md-0", attrs: { md: "6" } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              label: "Ort",
                              state: _vm.cityValid,
                              "invalid-feedback": "Bitte gib einen Ort ein",
                              "feedback-beneath": ""
                            }
                          },
                          [
                            _c("b-input", {
                              model: {
                                value: _vm.city,
                                callback: function($$v) {
                                  _vm.city = $$v
                                },
                                expression: "city"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "8" } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              label: "Straße",
                              state: _vm.streetValid,
                              "invalid-feedback": "Bitte gib eine Straße ein",
                              "feedback-beneath": ""
                            }
                          },
                          [
                            _c("b-input", {
                              model: {
                                value: _vm.street,
                                callback: function($$v) {
                                  _vm.street = $$v
                                },
                                expression: "street"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-3 mt-md-0", attrs: { md: "4" } },
                      [
                        _c(
                          "FormGroup",
                          {
                            attrs: {
                              label: "Hausnummer",
                              state: _vm.streetNumberValid,
                              "invalid-feedback":
                                "Bitte gib eine Hausnummer ein",
                              "feedback-beneath": ""
                            }
                          },
                          [
                            _c("b-input", {
                              model: {
                                value: _vm.streetNumber,
                                callback: function($$v) {
                                  _vm.streetNumber = $$v
                                },
                                expression: "streetNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: { label: "UID", "feedback-beneath": "" }
                              },
                              [
                                _c("b-input", {
                                  model: {
                                    value: _vm.vatNumber,
                                    callback: function($$v) {
                                      _vm.vatNumber = $$v
                                    },
                                    expression: "vatNumber"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "8" } },
                          [
                            _c(
                              "FormGroup",
                              {
                                attrs: {
                                  label: "Website des Unternehmens",
                                  "feedback-beneath": ""
                                }
                              },
                              [
                                _c("b-input", {
                                  model: {
                                    value: _vm.website,
                                    callback: function($$v) {
                                      _vm.website = $$v
                                    },
                                    expression: "website"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isExternal
        ? _c(
            "section",
            [
              _c("h3", [_vm._v("Daten eures Auftraggebers")]),
              _vm._v(" "),
              _c(
                "FormGroup",
                {
                  attrs: {
                    label:
                      "Firmenname: vollständiger Firmenname des zukünftigen Arbeitgebers - findest du im Impressum der Firmen-Webseite",
                    state: _vm.externalCompanyNameValid,
                    "invalid-feedback": "Bitte gib den Firmennamen ein",
                    "feedback-beneath": ""
                  }
                },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.externalCompanyName,
                      callback: function($$v) {
                        _vm.externalCompanyName = $$v
                      },
                      expression: "externalCompanyName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "my-4 text-right" },
        [
          _c("Button", {
            attrs: {
              text: "Speichern",
              icon: "checkmark",
              disabled: !_vm.dataValid || _vm.saving,
              loading: _vm.saving
            },
            on: { click: _vm.save }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "bullet-points mt-3 pl-4" }, [
      _c("li", [_vm._v("die Angabe eures Auftraggebers")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "die Angabe deines Unternehmens, in welchem du als externer Vermittler/Berater/Dienstleister\n\t\t\t\t\t\ttätig bist\n\t\t\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }